import React, { useState, useEffect, useRef } from "react";
import {
  getaxiosRequestWithToken,
  postaxiosRequestWithToken, deleteaxiosRequestWithToken
} from "../../api/api";
import { Accordion, Modal, Button, Form, Spinner } from "react-bootstrap";
import { showToast } from "../../services/toastifyservices";
import { handleSession } from "../../api/apiSessionHandle";
import { useNavigate } from "react-router-dom";
import CommonSpinner from "../../services/commonSpinner";
import "./appoinment.css";
import Pusher from "pusher-js";
import endpoints from "../../api/EndPoints";
import { PaginationControls } from "../../components/pagination";
import { FiShoppingBag, FiTrash2 } from 'react-icons/fi';
import Swal from "sweetalert2";

const Appointment = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("pending");
  const [appointmentSource, setappointmentSource] = useState("");
  const [appointmentData, setappoientmentdata] = useState([]);
  const [patientData, setPatientData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [isbtnLoading, setbtnIsLoading] = useState(false);
  const [date, setDate] = useState("");
  const [errors, setErrors] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [showPatientStatusModel, setshowPatientStatusModel] = useState(false);
  const [patientstatus, setpatientstatus] = useState('');
  const [updatePatientId, setupdatePatientId] = useState('');
  //! Pagination state
  const [currentPage, setCurrentPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState();
  const [totalPages, setTotalPages] = useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [activeKey, setActiveKey] = useState(null);
  const [documentdata, setdocumentdata] = useState([]);
  const [loadingAppointmentId, setLoadingAppointmentId] = useState(null);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setDate(today);
  }, []);

  //! pusher implementation ....
  useEffect(() => {
    var pusher = new Pusher("f5d7f359a1682ae86bd6", {
      cluster: "mt1",
    });

    var channel = pusher.subscribe("patient-channel");
    channel.bind("patient-event", function (data) {
      setRefresh(true);
    });
    return () => {
      channel.unbind("patient-event");
      pusher.unsubscribe("patient-channel");
    };
  }, []);

  const handleShowModal = (appointment) => {
    const patient = appointment.patient || {};
    setPatientData({
      first_name: patient.name || "",
      last_name: "",
      date_of_birth: "",
      phone_number: "",
      email_address: patient.email || "",
      gender: "",
      insurance_carrier: appointment.insurance?.name || "",
      insurance_plan: "",
      insurance_group_number: "",
      insurance_member_id: "",
    });
    setShowModal(true);
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPatientData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };
  const savePatient = async () => {
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      try {
        const Payload = {
          first_name: patientData.first_name,
          last_name: patientData.last_name,
          date_of_birth: patientData.date_of_birth,
          phone_number: patientData.phone_number,
          email_address: patientData.email_address,
          gender: patientData.gender,
          insurance_carrier: patientData.insurance_carrier,
          insurance_plan: patientData.insurance_plan,
          insurance_group_number: patientData.insurance_group_number,
          insurance_member_id: patientData.insurance_member_id,
        };
        setLoading(true);
        setbtnIsLoading(true);
        const response = await postaxiosRequestWithToken(
          "assistant_api/create-patient",
          Payload
        );
        if (response.success) {
          showToast("success", response.data.message);
        }
      } catch (error) {
        //;
        showToast("error", error.response?.data.message);
        setLoading(false);
        setbtnIsLoading(false);
      } finally {
        setLoading(false);
        setbtnIsLoading(false);
        setShowModal(false);
      }
    }
  };

  const validate = () => {
    const validationErrors = {};
    if (!patientData.first_name)
      validationErrors.first_name = "First Name is required";
    if (!patientData.last_name)
      validationErrors.last_name = "Last Name is required";
    if (!patientData.date_of_birth)
      validationErrors.date_of_birth = "Date of Birth is required";
    if (!patientData.phone_number)
      validationErrors.phone_number = "Phone Number is required";
    if (!patientData.email_address)
      validationErrors.email_address = "Email Address is required";
    if (!patientData.gender) validationErrors.gender = "Gender is required";
    if (!patientData.insurance_carrier)
      validationErrors.insurance_carrier = "Insurance Carrier is required";
    if (!patientData.insurance_plan)
      validationErrors.insurance_plan = "Insurance Plan is required";
    if (!patientData.insurance_group_number)
      validationErrors.insurance_group_number = "Group Number is required";
    if (!patientData.insurance_member_id)
      validationErrors.insurance_member_id = "Member ID is required";

    return validationErrors;
  };

  const handleCloseModal = () => setShowModal(false);

  //--------------------------on Search Button---------------------//
  const handleSearch = async (e) => {
    if (e) {
      e.preventDefault();
    }
    const Payload = {
      status: status,
      appointment_source: appointmentSource,
      //  date: date,
    };
    setLoading(true);

    try {
      const response = await getaxiosRequestWithToken(endpoints.GetAppoinments, Payload);
      if (response.success) {
        //;
        const resData = response.data;
        if (Array.isArray(resData)) {
          setappoientmentdata([]);
          showToast("error", response.message);
        } else if (Array.isArray(resData.data) && resData.data.length > 0) {
          setappoientmentdata(resData.data);
          setRowsPerPage(resData.per_page);
          setCurrentPage(resData.current_page);
          setTotalPages(Math.ceil(resData.total / resData.per_page));
        } else {
          setappoientmentdata([]);
          showToast("error", response.message);
        }

        setLoading(false);

      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      setLoading(false);
      handleSession(error.response?.data, navigate);
      handleSession(error.response.data, navigate);
    }
  };
useEffect(() => {
    handleSearch();
  }, []);
  useEffect(() => {
    if (refresh) {
      handleSearch();
      setRefresh(false);
    }
  }, [refresh]);

  // const handleDocumentClick = (filePath) => {
  //   console.log("filePath", filePath);
  //   //window.open(filePath, '_blank');
  // };

  const handleUpdatePatientStatus = (row) => {
    setupdatePatientId(row.id)
    setshowPatientStatusModel(true)
    setpatientstatus(row.status)
  }

  const handleClose = () => {
    setshowPatientStatusModel(false);
  };

  const handleStatusChange = (event) => {
    setpatientstatus(event.target.value);
  };

  const UpdatePatientStatus = async () => {

    try {
      setLoading(true);
      const payload = {
        id: updatePatientId.toString(),
        status: patientstatus
      };
      const response = await postaxiosRequestWithToken("assistant_api/update-Appt-Status", payload);
      if (response.success) {
        showToast('success', response.message);
        handleSearch();
      }

    } catch (error) {

      setLoading(false);
      showToast('error', error.response?.data.message);
      handleSession(error.response?.data, navigate);
    } finally {
      setLoading(false);
      setshowPatientStatusModel(false);

    }
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      fetchAppoiment(page);
    }
  };
  //! handle rows per page
  const handleRowsPerPageChange = (e) => {
    const newLimit = parseInt(e.target.value, 10);
    setRowsPerPage(newLimit);
    fetchAppoiment(currentPage, newLimit);
  };


  const fetchAppoiment = async (page) => {
    setLoading(true)
    const payload = {
      page: page,
      status: status,
      appointment_source: appointmentSource,
    }

    try {
      const response = await getaxiosRequestWithToken(endpoints.GetAppoinments, payload);
      if (response.success) {
        //;
        const resData = response.data;

        if (Array.isArray(resData)) {
          setappoientmentdata([]);
          showToast("error", response.message);
        } else if (Array.isArray(resData.data) && resData.data.length > 0) {

          setappoientmentdata(resData.data);
          setRowsPerPage(resData.per_page);
          setCurrentPage(resData.current_page);
          setTotalPages(Math.ceil(resData.total / resData.per_page));
        } else {
          setappoientmentdata([]);
          showToast("error", response.message);
        }

        setLoading(false);

      }
    } catch (error) {
      showToast("error", error.response?.data.message);
      setLoading(false);
      handleSession(error.response?.data, navigate);
      handleSession(error.response.data, navigate);
    }
  }

  const handleAccordionOpen = (key) => {
    setActiveKey(key);

    appoimentSelectedAccordion(key)
  };

  const appoimentSelectedAccordion = async (key) => {
    const selectedAppointment = appointmentData.find((a) => a.id.toString() === key);
    if (selectedAppointment) {
      // 👇 Call your function here
      fetchData(selectedAppointment.patient_pool.id, selectedAppointment.id);
    }
  }

  const fetchData = async (patientPoolId, appointmentId) => {
    setLoadingAppointmentId(appointmentId);
    try {
      const response = await getaxiosRequestWithToken(`${endpoints.GetPatientDocs}?patient_pool_id=${patientPoolId}`);
      if (response.success) {
        const normalizedData = (response.data.data || []).map((item) => ({
          id: item.id,
          patient_name: `${item.patient_pool?.first_name || ""} ${item.patient_pool?.last_name || ""}`,
          file_path: item.url,
          source: "get-patient-docs"
        }));
        setdocumentdata(normalizedData);
      } else {
        showToast("error", "No Record Found");
      }
    } catch (error) {
      showToast('error', error.response?.data.message);
      handleSession(error.response?.data, navigate);
    } finally {
      setLoadingAppointmentId(null); // Only clear loading when this fetch completes
      setRefresh(false);
    }
  };
  const handleDocumentClick = (filePath) => {
    window.open(filePath, '_blank');
  };

  const handleDelete = async (documentId) => {
    Swal.fire({
      title: "Do you want to delete this?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      icon: "question"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const document = documentdata.find((doc) => doc.id === documentId);
          if (!document) return;

          const params = { id: documentId };
          let response;
          if (document.source === "get-patient-docs") {
            response = await deleteaxiosRequestWithToken("assistant_api/delete-patient-doc", documentId);
          } else {
            response = await postaxiosRequestWithToken("assistant_api/delete-document", params);
          }
          if (response.success) {
            showToast("success", response.message);
            appoimentSelectedAccordion(activeKey)
          } else {
            showToast("error", response.message || "Failed to delete the document");
          }
        } catch (error) {
          showToast("error", "An unexpected error occurred while deleting the document");
        }
      }
    });
  };

  return (
    <div className="mt-3 p-2 md:p-10 bg-gray-200">
      <div className="card">
        <span className="text-start font-bold ml-4 p-2 headingtext">
          Appointments
        </span>
      </div>

      <form onSubmit={handleSearch}>
        <div className="card mt-3">
          <div className="row mt-3 mb-2 py-2">
            <div className="col-md-3 ml-3">
              <label
                htmlFor="statusSelect"
                className="form-label font-bold mb-1" // `mb-1` to add some space between the label and the dropdown
                style={{ display: "block" }} // Ensure label takes up full width
              >
                Status <span className="text-red">*</span>
              </label>
              <div className="d-flex">
                <select
                  className="form-select me-2" // Added margin to the right for spacing between dropdown and button
                  aria-label="Default select example"
                  id="statusSelect"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  required
                >
                  <option value="pending">Pending</option>
                  <option value="completed">Completed</option>
                  <option value="confirmed">Confirmed</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </div>
            </div>
            <div className="col-md-3 ml-3">
              <label
                htmlFor="SourceSelect"
                className="form-label font-bold mb-1"
                style={{ display: "block" }}
              >
                Appointment Source <span className="text-red">*</span>
              </label>
              <div className="d-flex">
                <select
                  className="form-select me-2"
                  aria-label="Default select example"
                  id="SourceSelect"
                  value={appointmentSource}
                  onChange={(e) => setappointmentSource(e.target.value)}
                  //required
                >
                  <option value="">Select Source</option>
                  <option value="azz">AZZ</option>
                  <option value="cpeg">CPEG</option>
                </select>
              </div>
            </div>
            {/* <div className="col-md-3">
              <label
                htmlFor="statusSelect"
                className="form-label font-bold mb-1"
                style={{ display: "block" }}
              >
                Date <span className="text-red">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                id="datePicker"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
              />
            </div> */}
            <div className="col-md-3 mt-4">
              <button
                className="btn btn-primary fw-bold btncolor"
                type="submit"
              >
                Search
              </button>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          {appointmentData.length > 0 ? (
            appointmentData.map((appointment) => {
              const patientData =
                appointment.created_by === "provider"
                  ? appointment.patient_pool
                  : appointment.patient;

              return (
                <div className="mb-3" key={appointment.id}>
                  <Accordion activeKey={activeKey} onSelect={handleAccordionOpen}>
                    <Accordion.Item eventKey={appointment.id.toString()}>
                      <Accordion.Header>
                        <div className="patient-info">
                          <div className="row mb-2 align-items-center">
                            <div className="col-auto">
                              <strong className="text-primary">Patient Name:</strong>
                            </div>
                            <div className="col">
                              <p className="mb-0">
                                {patientData?.name ||
                                  `${patientData?.first_name || ""} ${patientData?.last_name || ""}` ||
                                  ""}
                              </p>
                            </div>
                          </div>
                          <div className="row mb-2 align-items-center">
                            <div className="col-auto">
                              <strong className="text-primary">Patient Phone:</strong>
                            </div>
                            <div className="col">
                              <p className="mb-0">{patientData?.phone || ""}</p>
                            </div>
                          </div>
                          <div className="row mb-2 align-items-center">
                            <div className="col-auto">
                              <strong className="text-primary">Doctor Name:</strong>
                            </div>
                            <div className="col">
                              <p className="mb-0">{appointment.provider?.name || ""}</p>
                            </div>
                          </div>
                          <div className="row mb-2 align-items-center">
                            <div className="col-auto">
                              <strong className="text-primary">Appt_Source:</strong>
                            </div>
                            <div className="col">
                              <p className="mb-0 uppercase">{appointment?.appointment_source || "Website"}</p>
                            </div>
                              
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="appointment-container">
                          <div className="">
                            <h5>Date and Time</h5>
                            <p>
                              <strong>Date:</strong> {appointment.date}
                            </p>
                            <p>
                              <strong>Time:</strong> {appointment.time}
                            </p>
                            <p>
                              <strong>Visit Type:</strong> {appointment.visit_type}
                            </p>
                            <p>
                              <strong>Mode:</strong> {appointment.mode}
                            </p>
                            <p>
                              <strong>Status:</strong> {appointment.status}
                            </p>
                          </div>
                          <div className="">
                            <h5>Address</h5>
                            <p>
                              <strong>Location:</strong> {appointment.address?.address || ""}
                            </p>
                            <p>
                              <strong>City:</strong> {appointment.address?.city || ""}
                            </p>
                            <p>
                              <strong>State:</strong> {appointment.address?.state || ""}
                            </p>
                          </div>
                          <div className="">
                            <h5>Insurance</h5>
                            <p>
                              <strong>Insurance Name:</strong> {appointment.insurance?.name || ""}
                            </p>
                          </div>
                          <div className="">
                            <h5>TalkEHR Statuses</h5>
                            <p>
                              <strong>Patient Status:</strong> {appointment.patient_pool?.mrn ? "Existing Patient" : "New Patient"}
                            </p>
                            <p>
                              <strong>Appointment Status:</strong> {appointment.azz_appointment_id ? "Appointment created in TalkEHR" : "Appointment not created "}
                            </p>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="document-list w-100">
                            {loadingAppointmentId === appointment.id ? (
                              <div className="text-center my-3">
                                <div className="spinner-border text-primary" role="status" style={{ width: "2.5rem", height: "2.5rem" }}>
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </div>
                            ) : (
                              documentdata.map((doc) => (
                                <div key={doc.id} className="document-item mb-4">
                                  <div className="card">
                                    <div className="card-body">
                                      <div className="d-flex justify-content-between align-items-center patient-name-container">
                                        <span className="patient-name h5 mb-0">{doc.patient_name}</span>
                                        <div className="d-flex">
                                          <button
                                            type="button"
                                            onClick={() => handleDocumentClick(doc.file_path)}
                                            className="btn btn-link me-2"
                                            title="View Document"
                                          >
                                            <FiShoppingBag size={24} />
                                          </button>
                                          <button
                                            type="button"
                                            onClick={() => handleDelete(doc.id)}
                                            className="btn btn-link"
                                            title="Delete Document"
                                            style={{ color: 'red' }}
                                          >
                                            <FiTrash2 size={24} />
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            )}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col text-end">
                            <Button
                              className="btn btn-primary fw-bold btncolor mb-3"
                              onClick={() => handleUpdatePatientStatus(appointment)}
                            >
                              Update Status
                            </Button>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>


              );
            })

          ) : (
            <div className="custom-style">{/* <p>No Records Found.</p> */}</div>
          )}

        </div>
      </form>
      {appointmentData.length > 0 ? (
        <div className="pagination-controls">
          <PaginationControls
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            onLimitPerPage={handleRowsPerPageChange}
          />
        </div>
      ) : (
        <>
        </>
      )}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <div className="modal-custom-content">
          <Modal.Header closeButton className="sticky-top modal-custom-header">
            <Modal.Title>Create Patient</Modal.Title>
          </Modal.Header>
          <Modal.Body className="modal-custom-body">
            <form>
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    name="first_name"
                    className="form-control"
                    value={patientData.first_name}
                    onChange={handleInputChange}
                  />
                  {errors.first_name && (
                    <div className="text-danger">{errors.first_name}</div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    name="last_name"
                    className="form-control"
                    value={patientData.last_name}
                    onChange={handleInputChange}
                  />
                  {errors.last_name && (
                    <div className="text-danger">{errors.last_name}</div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label className="form-label">Date of Birth</label>
                  <input
                    type="date"
                    name="date_of_birth"
                    className="form-control"
                    value={patientData.date_of_birth}
                    onChange={handleInputChange}
                  />
                  {errors.date_of_birth && (
                    <div className="text-danger">{errors.date_of_birth}</div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="text"
                    name="phone_number"
                    className="form-control"
                    value={patientData.phone_number}
                    onChange={handleInputChange}
                  />
                  {errors.phone_number && (
                    <div className="text-danger">{errors.phone_number}</div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    name="email_address"
                    className="form-control"
                    value={patientData.email_address}
                    onChange={handleInputChange}
                  />
                  {errors.email_address && (
                    <div className="text-danger">{errors.email_address}</div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label className="form-label">Gender</label>
                  <select
                    name="gender"
                    className="form-control"
                    value={patientData.gender}
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                  {errors.gender && (
                    <div className="text-danger">{errors.gender}</div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label className="form-label">Insurance Carrier</label>
                  <input
                    type="text"
                    name="insurance_carrier"
                    className="form-control"
                    value={patientData.insurance_carrier}
                    onChange={handleInputChange}
                  />
                  {errors.insurance_carrier && (
                    <div className="text-danger">
                      {errors.insurance_carrier}
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label className="form-label">Insurance Plan</label>
                  <input
                    type="text"
                    name="insurance_plan"
                    className="form-control"
                    value={patientData.insurance_plan}
                    onChange={handleInputChange}
                  />
                  {errors.insurance_plan && (
                    <div className="text-danger">{errors.insurance_plan}</div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label className="form-label">Group Number</label>
                  <input
                    type="text"
                    name="insurance_group_number"
                    className="form-control"
                    value={patientData.insurance_group_number}
                    onChange={handleInputChange}
                  />
                  {errors.insurance_group_number && (
                    <div className="text-danger">
                      {errors.insurance_group_number}
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label className="form-label">Member ID</label>
                  <input
                    type="text"
                    name="insurance_member_id"
                    className="form-control"
                    value={patientData.insurance_member_id}
                    onChange={handleInputChange}
                  />
                  {errors.insurance_member_id && (
                    <div className="text-danger">
                      {errors.insurance_member_id}
                    </div>
                  )}
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer className="sticky-bottom modal-custom-footer">
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button
              className="btn btn-primary fw-bold btncolor"
              onClick={savePatient}
              disabled={isbtnLoading} // Disable button while loading
            >
              {isbtnLoading ? (
                <>
                  <div
                    className="spinner-border text-light spinner-border-sm"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <span className="ms-2">Saving Patient...</span>{" "}
                  {/* Optional: text next to spinner */}
                </>
              ) : (
                "Save Patient"
              )}
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
      <Modal show={showPatientStatusModel} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select Appointment Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="appointmentStatus">
              <Form.Label>Status</Form.Label>
              <Form.Select value={patientstatus} onChange={handleStatusChange}>
                <option value="pending">Pending</option>
                <option value="confirmed">Confirmed</option>
                <option value="cancelled">Cancelled</option>
                <option value="completed">Completed</option>

              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={UpdatePatientStatus} disabled={loading}>
            {loading ? (
              <>
                <Spinner animation="border" size="sm" /> Updating...
              </>
            ) : (
              "Save Changes"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      {loading && <CommonSpinner />}
    </div>
  );
};

export default Appointment;
